import loadjs from "loadjs"
import { useEffect } from "react"

import Image from "components/ui/image"
import { IS_US, IS_CA, IS_UK } from "helpers/application"

const HolidayGiftFinder = () => {
  useEffect(() => {
    const loadSplash = () => {
      window.DIGIOH_API.LIGHTBOX.loadLightbox(
        IS_US()
          ? "ef400bc9-41b3-4ddc-b5a4-7d73722ad319" // US 316518
          : IS_CA()
            ? "ae4470a1-977e-4e60-be1f-a63219da9941" // CA 316519
            : IS_UK()
              ? "7bcedb67-e7fa-49ea-bae6-85fb38848318" // UK 316520
              : "f826c82f-6513-4bba-b315-b124f248de4b" // AU 317099
      )
    }

    if (window.DIGIOH_API && window.DIGIOH_API.LIGHTBOX) {
      loadSplash()
    } else {
      loadjs(
        [
          `https://www.lightboxcdn.com/vendor/7c3a4ec6-f10d-4926-b14d-64ee5d0a9611/lightbox_speed.js?mb=${new Date().getTime()}`,
        ],
        { async: true, returnPromise: true }
      )
        .then(() => loadSplash())
        .catch((err) => console.log(`Error loading quiz: ${err}`))
    }
  }, [])

  return (
    <div
      className="[&>*:nth-child(n+2)]:hidden"
      id="gift-finder-splash"
      style={{ minHeight: "560px" }}
    >
      <div className="my-48 text-center" style={{ minHeight: "350px" }}>
        <Image
          alt="Loading"
          height="175"
          lazyload={false}
          src={require("images/layout/loadinglarge.gif")}
          width="175"
        />
      </div>
    </div>
  )
}

export default HolidayGiftFinder
